module.exports = __webpack_public_path__ + "img/family-emptyState.9258f3cb.svg";